import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { Box, Button, FormControl, InputLabel } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import {
  authenticateService,
  checkServiceAuth,
  revokeService,
} from "../../../APICalling/ServiceAPICalling";
import {
  SERVICE_API_KEY_API_NAME,
  SERVICE_CONN,
  SERVICE_NAME,
} from "../../../config/serviceConstant";
import RevokeDialog from "./RevokeDialog";
import { setUpOrgVariable } from "../../../APICalling/ZohoAPICalling";
import {
  getOpenSnakErrorData,
  getOpenSnakSuccessData,
} from "../../../config/otherConstant";

const ZOHO = window.ZOHO;
function ServiceAuthentication({
  serviceAuth,
  setServiceAuth,
  setServiceApiKey,
  orgId,
  apiKey,
  dataCenterUrl,
  api_key,
  set_api_key,
  setShowPassword,
  setSnack,
}) {
  const serviceHeaders = {
    orgid: orgId,
    connname: SERVICE_CONN,
    apikey: apiKey,
  };

  const [authLoading, setAuthLoading] = useState(true);
  const [revokeLoading, setRevokeLoading] = useState(false);

  const handleAuthenticateService = async () => {
    try {
      setAuthLoading((prev) => true);
      const isAuthenticated = await authenticateService({
        serviceApiKey: api_key,
        headers: serviceHeaders,
      });
      if (!isAuthenticated) {
        setAuthLoading((prev) => false);

        setSnack(
          getOpenSnakErrorData(
            "Error!!! Please provide a valid cellcast API Key",
            10 * 1000
          )
        );
        return;
      }
      // todo Set api key in variable

      setSnack(getOpenSnakSuccessData());
      setServiceApiKey((prev) => api_key);
      setServiceAuth((prev) => true);
      setShowPassword((prev) => false);
      await setUpOrgVariable(ZOHO, SERVICE_API_KEY_API_NAME, api_key);
      // todo set serviceAuth true
    } catch (error) {
      setSnack(
        getOpenSnakErrorData(
          "Error!!! Please provide a valid cellcast API Key",
          10 * 1000
        )
      );
      // return;
    }
    setAuthLoading((prev) => false);
  };

  const handleRevokeService = async () => {
    try {
      setRevokeLoading((prev) => true);
      const revokeResp = await revokeService(serviceHeaders);
      console.log({ revokeResp });
      // todo if ture set variable empty
      if (revokeResp) {
        setSnack(getOpenSnakSuccessData());
        await setUpOrgVariable(ZOHO, SERVICE_API_KEY_API_NAME, "");
        set_api_key((prev) => "");
        setServiceAuth((prev) => false);
      }
      // else return

      setSnack(getOpenSnakErrorData());
    } catch (error) {
      console.log(error);

      setSnack(getOpenSnakErrorData());
    }
    setRevokeLoading((prev) => false);
  };

  const checkAuth = async (cb) => {
    const zohoStatus = await checkServiceAuth(serviceHeaders);
    console.log({ zohoStatus });
    cb(zohoStatus);
  };

  useEffect(() => {
    if (orgId && apiKey) {
      checkAuth((bool) => {
        setServiceAuth((prev) => bool);
        setAuthLoading((prev) => false);
      });
    }
  }, []);

  if (authLoading) {
    return (
      <Button disabled variant="outlined">
        Authenticating...
      </Button>
    );
  }

  if (revokeLoading) {
    return (
      <Button disabled variant="outlined">
        Revoking...
      </Button>
    );
  }

  if (serviceAuth) {
    return (
      <RevokeDialog
        service={"cellcast"}
        handleRevokeService={handleRevokeService}
      />
    );
  }

  if (!serviceAuth) {
    return (
      <Button
        disabled={!api_key || api_key?.length != 40}
        variant="contained"
        onClick={handleAuthenticateService}
      >
        Authenticate {SERVICE_NAME}
      </Button>
    );
  }
  return <div></div>;
}

export default ServiceAuthentication;
